<template>
    <div>
        <el-button type="primary" @click="getCommodity">选择用户</el-button>
        <el-button type="danger" @click="batchDelete">批量删除</el-button>
        <el-table
                size="small"
                :data="multipleSelection"
                ref="tableRef"
                stripe
                border
                highlight-current-row
                style="max-width: 1450px;margin-top: 20px"
        >
            <el-table-column align="center" label width="180" type="selection"></el-table-column>
            <el-table-column align="center" label="id" width="120">
                <template slot-scope="scope">
                    <span>{{scope.row.id}}</span>
                </template>
            </el-table-column>
            <el-table-column width="270" align="center" label="注册时间">
                <template slot-scope="scope">
                    <span>{{scope.row.createTime}}</span>
                </template>
            </el-table-column>
            <el-table-column width="120" align="center" label="昵称">
                <template slot-scope="scope">
                    <span>{{scope.row.nickname}}</span>
                </template>
            </el-table-column>
            <el-table-column width="120" align="center" label="头像">
                <template slot-scope="scope">
                    <img :src="scope.row.avatar" style="width:80px;height:80px;object-fit: cover" />
                </template>
            </el-table-column>
            <el-table-column width="180" align="center" label="号码">
                <template slot-scope="scope">
                    <span>{{scope.row.mobile}}</span>
                </template>
            </el-table-column>
            <el-table-column width="120" align="center" label="总经验值">
                <template slot-scope="scope">
                    <span>{{scope.row.pointAmount || '无'}}</span>
                </template>
            </el-table-column>
            <el-table-column width="120" align="center" label="等级">
                <template slot-scope="scope">
                    <span>{{scope.row.levelName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="{ row,$index }">
                    <el-button type="danger" size="mini" @click="removeUserList(row,$index)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <users :visible.sync="dlUserShow" :select-list.sync="dialogUserList" @on-select="onSelect"></users>
    </div>

</template>
<script>
import { mapGetters } from 'vuex'
import users from '../../components/users/index.vue'
import { getUser } from '@/api/demo/user'
export default {
  name: 'selectUser',
  computed: {
    ...mapGetters(['elements'])
  },
  components: {
    users
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    accountIds: {
      handler: function (val, oldVal) {
        this.getSearch()
      },
      deep: true
    },
    value: {
      handler: function (val, oldVal) {
        console.log('watch', val)
        this.accountIds = [...val]
      },
      deep: true
    }
  },
  data () {
    return {
      accountIds: [], // 用户id
      multipleSelection: [], // 用户数据
      dlUserShow: false,
      dialogUserList: [], // 弹窗用户列表
      listLoading: false
    }
  },
  created () {
    let that = this
  },
  mounted () {
    this.accountIds = [...this.value]
  },
  methods: {
    // 获取用户列表
    async getSearch () {
      if (this.accountIds.length === 0) {
        this.multipleSelection = []
        return
      }
      let that = this
      that.listLoading = true
      let params = {
        page: 1,
        size: 1000,
        accountIds: this.accountIds
      }
      let res = await getUser(params)
      that.listLoading = false
      console.log('getUser', res)
      that.multipleSelection = res.records
    },
    // 清空
    cancel (form) {
      this.$refs[form].resetFields()
    },
    // 选择用户
    getCommodity () {
      this.dlUserShow = true
      this.dialogUserList = this.multipleSelection // 勾选回选
    },
    // 用户弹窗确认选择
    async onSelect (data) {
      let that = this
      if (this.multipleSelection == '') {
        data.forEach(item => {
          this.multipleSelection.push({
            specificCode: item.specificCode,
            id: item.id,
            createTime: item.createTime,
            nickname: item.nickname,
            avatar: item.avatar,
            mobile: item.mobile,
            pointAmount: item.pointAmount,
            levelName: item.levelName
          })
        })
      } else {
        data.map(item => {
          this.multipleSelection.push({
            specificCode: item.specificCode,
            id: item.id,
            createTime: item.createTime,
            nickname: item.nickname,
            avatar: item.avatar,
            mobile: item.mobile,
            pointAmount: item.pointAmount,
            levelName: item.levelName
          })
        })
      }
      this.$nextTick(function () {
        var result = []
        var obj = {}
        // 数组去重
        for (var i = 0; i < this.multipleSelection.length; i++) {
          if (!obj[this.multipleSelection[i].id]) {
            result.push(this.multipleSelection[i])
            obj[this.multipleSelection[i].id] = true
          }
        }
        this.multipleSelection = result
        this.updateList()
      })
    },
    // 删除用户
    async removeUserList (row, index) {
      let that = this
      this.multipleSelection.splice(index, 1)
      this.updateList()
    },
    updateList () {
      let accountIds = []
      this.multipleSelection.forEach(item => {
        accountIds.push(item.id)
      })
      this.accountIds = [...new Set(accountIds)]
      this.$emit('update:value', this.accountIds)
    },
    // 批量删除
    async batchDelete () {
      let that = this
      if (!that.$refs.tableRef.selection.length) {
        that.$message.error('请勾选要删除的用户')
        return
      }
      var seid = that.$refs.tableRef.selection
      let itmu = that.multipleSelection
      for (let i = 0; i < seid.length; i++) {
        for (let y = 0; y < itmu.length; y++) {
          if (JSON.stringify(itmu[y]) == JSON.stringify(seid[i])) {
            // 判断是否相等，相等就删除
            console.log(itmu[y])
            that.multipleSelection.splice(y, 1)
            // console.log(that.multipleSelection, "that.form.multipleSelection");
          }
        }
      }
      that.updateList()
    },
    // 有效时间
    dataSearch (e) {
      this.form.giftFailureTime = e
    }
  }
}
</script>
<style scope>
.dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
}
.margins {
    margin-bottom: 30px !important;
}
</style>
